import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemText,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import { convertToBoolean, SIGNATURE_TYPES } from "../constants/constants";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = () => createStyles({});
const inputTypes = [
  {
    value: "TEXT",
    label: "Text",
  },
  {
    value: "DATE",
    label: "Date",
  },
  {
    value: "NUMBER",
    label: "Number (Digits only)",
  },
  {
    value: "SIGNATURE",
    label: "Signature",
  },
];
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  defaultValue?: any;
  handleOnSubmit: any;
  companyData: any;
  editData: any;
}

class ItemSignotoriesDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    type: "",
  };
  getSignitureResponse = (typeKey: any) => {
    let response = {};
    SIGNATURE_TYPES.map((responseType: any) => {
      if (responseType.value === typeKey) {
        response = responseType;
      }
      return null;
    });
    return response;
  };
  render() {
    const { title, open, handleClose, handleOnSubmit, defaultValue, editData } =
      this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                editData && editData.title
                  ? editData
                  : {
                      title: defaultValue ? defaultValue : "",
                      type: "Sign",
                      who: "",
                      signiureRequired: false,
                      signatureType: {
                        label: "",
                        value: "",
                      },
                    }
              }
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                handleOnSubmit(values);
                resetForm();
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                setFieldValue,
                isValid,
              }) => (
                <Form>
                  <div>
                    <TextField
                      style={{ margin: 10 }}
                      id={"title"}
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name={"title"}
                      disabled={defaultValue ? true : false}
                      label={"Title"}
                      fullWidth
                    />
                    <TextField
                      style={{ margin: 10 }}
                      select
                      id={"type"}
                      label={"Input type"}
                      margin="dense"
                      value={values.type ? values.type : ""}
                      SelectProps={{
                        value: "SIGNATURE",
                      }}
                      disabled={defaultValue ? true : false}
                      onChange={handleChange("type")}
                      fullWidth
                    >
                      {inputTypes.map((option: any) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    {this.props.companyData &&
                      this.props.companyData.positions &&
                      this.props.companyData.positions.length > 0 && (
                        <div>
                          <TextField
                            style={{ margin: 10 }}
                            select
                            id={"who"}
                            label={"Who to sign"}
                            margin="dense"
                            value={values.who ? values.who : ""}
                            onChange={(event: any) => {
                              setFieldValue("who", event.target.value);
                            }}
                            fullWidth
                          >
                            {this.props.companyData.positions.map(
                              (option: any) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                          <FormControlLabel
                            style={{ margin: 1 }}
                            control={
                              <Checkbox
                                id={"signiureRequired"}
                                name={"signiureRequired"}
                                checked={
                                  values.signiureRequired
                                    ? convertToBoolean(values.signiureRequired)
                                    : false
                                }
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "signiureRequired",
                                    event.target.checked
                                  );
                                }}
                                value="signiureRequired"
                              />
                            }
                            label="Signature required"
                          />
                        </div>
                      )}
                    {values.signiureRequired && (
                      <TextField
                        style={{
                          width: "80%",
                          margin: 10,
                          height: 50,
                        }}
                        select
                        id={"signatureType"}
                        label={"Signature Type"}
                        value={
                          values.signatureType && values.signatureType.value
                            ? values.signatureType.value
                            : ""
                        }
                        onChange={(event) => {
                          setFieldValue(
                            "signatureType",
                            this.getSignitureResponse(event.target.value)
                          );
                        }}
                        fullWidth={true}
                      >
                        {SIGNATURE_TYPES.map((option: any, index: any) => (
                          <MenuItem key={index.toString()} value={option.value}>
                            <Grid container spacing={3}>
                              <Grid item xs={3}>
                                <ListItemText>{option.label}</ListItemText>
                              </Grid>
                            </Grid>
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                    <DialogActions>
                      <Button
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        {"CANCEL"}
                      </Button>
                      <Button type="submit" disabled={!isValid}>
                        {"SAVE"}
                      </Button>
                    </DialogActions>
                  </div>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ItemSignotoriesDialog);
